export const socialProjectExportColumns = [
	{ label: 'Sr No', key: 'index' },
	{
		label: 'Title',
		render: p => p?.title || '',
	},

	{
		label: 'Category',
		render: p => p?.category?.name || '',
	},

	{
		label: 'Community',
		render: p => p?.hub?.name || '',
	},

	{
		label: 'Sanstha',
		render: p => p?.sanstha?.name || '',
	},
	{
		label: 'Received Amount (Rs)',
		render: p => p?.receivedAmount || 0,
	},
	{
		label: 'Start Date',
		render: p => (p?.startDate ? new Date(p.startDate).toLocaleDateString('en-IN') : ''),
	},

	{
		label: 'End Date',
		render: p => (p?.endDate ? new Date(p.endDate).toLocaleDateString('en-IN') : 'Ongoing'),
	},

	{
		label: 'Status',
		render: p => p?.status || 'N/A',
	},
]
